import { useCallback, useMemo, useState } from 'react';
import { CookieService } from '../../../../../services/cookie-service';
import { PromotionalPlanCookieName } from '../../../../../constants/cookies';
import { useDoesSellerHavePromotionalOffer } from './hooks/use-does-seller-have-promotional-offer';

/**
 * Returns a shouldShow flag and hide handler for the modal we show to users who navigate to the app via Marketing-provided email link
 * @returns {{ hideMarketingHandoffModal: () => void, shouldShowMarketingHandoffModal: boolean }}
 */
export const useGetEmailMarketingHandoffModalDetails = () => {
  const [showEmailMarketingModal, setShouldShowEmailMarketingModal] = useState(
    /** @type {boolean} */ (CookieService.getCookieValue(PromotionalPlanCookieName)),
  );

  const hasPromotionalOffer = useDoesSellerHavePromotionalOffer();
  const shouldShowMarketingHandoffModal = showEmailMarketingModal && hasPromotionalOffer;

  const hideMarketingHandoffModal = useCallback(() => {
    CookieService.removeCookie(PromotionalPlanCookieName);
    setShouldShowEmailMarketingModal(false);
  }, []);

  return useMemo(
    () => ({
      hideMarketingHandoffModal,
      shouldShowMarketingHandoffModal,
    }),
    [hideMarketingHandoffModal, shouldShowMarketingHandoffModal],
  );
};
